import { render, staticRenderFns } from "./TournamentParser.vue?vue&type=template&id=6dd65c70&lang=pug"
import script from "./TournamentParser.vue?vue&type=script&lang=js"
export * from "./TournamentParser.vue?vue&type=script&lang=js"
import style0 from "./TournamentParser.vue?vue&type=style&index=0&id=6dd65c70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports